import {pushWarnToast} from 'features/notifications/redux/actions';
import {put} from 'redux-saga/effects';
import {ITransactionResponse} from 'types/TransactionResponse';

export function* handleWarnings(warnings?: ITransactionResponse['warnings']) {
   if (warnings) {
      for (const [key, warnMessages] of Object.entries(warnings)) {
         for (const message of warnMessages) {
            yield put(pushWarnToast(message));
         }
      }
   }
}
